import React from 'react';
import { NonIndexRouteObject, createBrowserRouter } from 'react-router-dom';

import Layout from './components/shared/Layout';
import Home from './components/home/Home';
import Contact from './components/contact/Contact';
import Medias from './components/medias/Medias';
import Society from './components/society/Society';
import Privacy from './components/privacy/Privacy';
import Politic from './components/politic/Politic';
import Team from './components/team/Team';
import Expertises from './components/expertises/Expertises';
import Valence from './components/valence/Valence';
import Reunion from './components/reunion/Reunion';
import Avignon from './components/avignon/Avignon';
import Rouen from './components/rouen/Rouen';
import Douai from './components/douai/Douai';
import Carjaune from './components/carjaune/Carjaune';
import TheSolution from './components/the-solution/TheSolution';
import MentionsLegales from './components/mentions-legales/MentionsLegales';
import LanguageRedirect from './components/shared/LanguageRedirect';
import { TranslateRoutes } from './components/shared/TranslateRoutes';
import LangGuard from './components/shared/LangGuard';
import Events from './components/events/Events';
import Event from './components/events/Event';
import EventsXMedias from './components/eventsxmedias/EventsXMedias';

const translateRoutes = TranslateRoutes();

export interface CustomRouteObject extends NonIndexRouteObject {
    children?: CustomRouteObject[],
    title?: string,
    visible?: boolean,
    close?: boolean
}

export const routes: CustomRouteObject[] = [
    {
        path: "/",
        element: <LanguageRedirect />
    },
    {
        path: "/:lang",
        element: <LangGuard><Layout /></LangGuard>,
        children: [
            // {
            //   path: "/charte",
            //   element: <Charte />
            // },
            {
                path: "",
                title: "Pages.Home.Menu",
                visible: true,
                close: true,
                element: <Home />
            },
            {
                path: translateRoutes.home,
                title: "Pages.Home.Menu",
                visible: true,
                close: true,
                element: <Home />
            },
            {
                path: translateRoutes.expertise,
                title: "Pages.Expertises.Menu",
                close: false,
                element: <Expertises />
                // children: [
                //   {
                //     path: "",
                //     title: "Pages.Expertises.SubMenu",
                //     close: true,
                //     element: <Expertises />
                //   },
                //   {
                //     path: "experiences",
                //     title: "Pages.Experiences.Menu",
                //     close: true,
                //     element: <Experiences />
                //   },
                // ]
            },
            {
                path: translateRoutes.solution,
                title: "Pages.Solution.Menu",
                close: true,
                element: <TheSolution />
                //children: [
                //  {
                //    path: "",
                //    title: "Pages.Solution.Menu",
                //    close: true,
                //    element: <TheSolution />
                //  },
                //  {
                //    path: "privacy",
                //    title: "Pages.Privacy.Menu",
                //    close: true,
                //    element: <Privacy />
                //  },
                //]
            },
            {
                path: translateRoutes.societe,
                title: "Pages.Society.Menu",
                close: true,
                element: <Society />
                //children: [
                //  {
                //    path: "",
                //    title: "Pages.Society.Menu",
                //    close: true,
                //    element: <Society />
                //  },
                //  {
                //    path: "team",
                //    title: "Pages.Team.Menu",
                //    close: true,
                //    element: <Team />
                //  }
                //]
            },
            {
                path: translateRoutes.medias,
                title: "Pages.Medias.Menu",
                visible: false,
                close: true,
                element: <Medias />
            },
            {
                path: translateRoutes.eventsxmedias,
                title: "Pages.EventsXMedias.Menu",
                visible: true,
                close: false,
                element: <EventsXMedias />
            },
            {
                path: translateRoutes.contact,
                title: "Pages.Contact.Menu",
                close: true,
                element: <Contact />
            },
            {
                path: translateRoutes.valence,
                title: "Pages.Valence.Menu",
                visible: false,
                close: false,
                element: <Valence />
            },
            {
                path: translateRoutes.reunion,
                title: "Pages.Reunion.Menu",
                visible: false,
                close: false,
                element: <Reunion />
            },
            {
                path: translateRoutes.avignon,
                title: "Pages.Avignon.Menu",
                visible: false,
                close: false,
                element: <Avignon />
            },
            {
                path: translateRoutes.douai,
                title: "Pages.Douai.Menu",
                visible: false,
                close: false,
                element: <Douai />
            },
            {
                path: translateRoutes.rouen,
                title: "Page.Rouen.Menu",
                visible: false,
                close: false,
                element: <Rouen />
            },
            {
                path: translateRoutes.carjaune,
                title: "Page.Carjaune.Menu",
                visible: false,
                close: false,
                element: <Carjaune />
            },
            {
                path: translateRoutes.cookie,
                title: "Pages.Cookies.Menu",
                visible: false,
                close: true,
                element: <Politic />
            },
            {
                path: translateRoutes.legal,
                title: "Pages.Legal.Menu",
                visible: false,
                close: true,
                element: <MentionsLegales />
            },
            // page raccourci a enlever plus tard
            {
                path: translateRoutes.team,
                title: "Pages.Team.Menu",
                visible: false,
                close: false,
                element: <Team />
            },
            {
                path: translateRoutes.events,
                title: "Pages.Events.Menu",
                visible: false,
                close: false,
                element: <Events />
            },
            {
                path: `${translateRoutes.events}/:id`,
                title: "Pages.Events.Details",
                visible: false,
                close: false,
                element: <Event />
            },
            {
                path: translateRoutes.privacy,
                title: "Pages.Privacy.Menu",
                visible: false,
                close: false,
                element: <Privacy />
            },
            {
                path: "*",
                title: "Pages.Privacy.Menu",
                visible: false,
                close: false,
                element: <LanguageRedirect showContent={true} />
            }
        ]
    }
];
export const router = createBrowserRouter(routes);
